<template>
    <div>
        <div class="right-title">
            <span>候选人基本信息详情</span>
            <el-button plain class="go-back" @click="goBack">返回</el-button>
        </div>
        <div class="content-box">
            <div class="cont-box">
                <div class="box-t">基本信息/账户信息</div>
                <div class="box-l">
                    <div class="img">
                        <img src="" alt="">
                    </div>

                    <div class="xinx">
                        <ul>
                            <li>
                                <span>姓名：</span>{{tableData.name}}
                            </li>
                            <li>
                                <span>性别：</span>男
                            </li>
                            <li>
                                <span>邮箱：</span>1231231231
                            </li>
                            <li>
                                <span>出生年月：</span>1988.22.22
                            </li>
                            <li>
                                <span>工作年限：</span>10年
                            </li>
                            <li>
                                <span>所在地：</span>石家庄
                            </li>
                            <li>
                                <span>电话号码：</span>1335528565
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="box-r">
                    <el-button plain class="go-back">审核通过</el-button>
                    <el-button plain class="go-back">审核不通过</el-button>
                    <el-button plain class="go-back">设置为不信任</el-button>
                </div>
                <div style="clear: both;"></div>
                <div class="jieshao">
                    <div class="jie-l">
                        <p class="p1">平台介绍</p>
                        <p class='p2'>善远·择贤2.0平台是善远咨询根据非营利组织特点推出的普惠型人才招聘平台。平台使用共享共建的理念，引入行业内的合作伙伴机制，通过行业人才的共享共建机制，共同打造领域内的窗口期人才池。 </p>
                    </div>
                    <div class="jie-r">
                        <div class="ewm">
                            <div class="ewmimg">
                                <img src="" alt="">
                            </div>
                            <p class='p3'>扫一扫关注微信公众号了解更多</p>
                            <p class='p4'>服务热线：400-888-8888</p>
                        </div>
                    </div>
                    <div style="clear: both;"></div>
                </div>
            </div>
            <footerBox class="footer"/>
        </div>

    </div>
</template>

<script>
    import footerBox from '../components/rightBottom'
    export default {
        name: "hxrDetail",
        data(){
            return {
                tableData:{
                    id:'1',
                    name:'张安',
                    chakan:'12:00',
                }
            }
        },
        methods:{
            goBack() {     //  返回上一页
                this.$tools.goBack()
            },
        },
        watch: {},
        components: {
            footerBox
        }
    }
</script>

<style scoped lang='scss'>
.cont-box {
    width: 96%;
    /*height: 500px;*/
    margin: 2%;
    background-color: #fff;
    /*overflow-y: scroll;*/
    /*padding-bottom: 50px;*/
    .box-t {
        width: 100%;
        font-weight: bold;
        font-size: 16px;
        line-height: 50px;
        text-indent: 30px;
        border: 1px solid #ccc;
    }
    .box-l {
        display: block;
        width: 80%;
        border: 1px solid #ccc;
        float: left;
        .img {
            width: 150px;
            height: 150px;
            border: 1px solid #000;
            margin-left: 100px;
            margin-top: 50px;
            img {
                width: 100%;
            }
        }
        .xinx {
            margin-left: 120px;
            margin-top: 30px;
            ul {
                display: block;
                li {
                    font-size: 14px;
                    line-height: 50px;
                    span {
                        margin-right: 20px;
                    }
                }
            }
        }

    }
    .box-r {
        float: right;
        width: 20%;
        margin-top: 20px;
        .go-back {
            width: 80%;
            margin-left: 10%;
            margin-bottom: 10px;
        }
    }
    .jieshao {
        width: 100%;
        margin-top: 20px;
        .jie-l {
            width: 49%;
            margin-left: 2%;
            display: inline-block;
            float: left;
            .p1 {
                font-size: 18px;
                font-weight: bold;
                margin-top: 10px;
                margin-bottom: 20px;
            }
            .p2 {
                font-size: 14px;
                line-height: 24px;
            }
        }
        .jie-r {
            width: 240px;
            display: inline-block;
            float: right;
            .ewm {
                width: 100%;
                margin-top: 20px;
                .ewmimg {
                    width: 110px;
                    height: 110px;
                    margin: 0 auto;
                    background-color: #0000ff;
                }
                .p3,.p4 {
                    width: 100%;
                    text-align: center;
                    font-size: 14px;
                    line-height: 24px;
                }
            }
        }
    }
}
</style>